import { toast } from "react-toastify";

import BulkAction from "common/components/BulkAction";
import type { Lead } from "common/types";

export function startLeadsBulkAction(
  actionFn: (lead: Lead, abortSignal: AbortSignal) => Promise<unknown>,
  leads: Lead[],
  renderToastTitle: (finishedItemsCount: number) => string,
  isAsync?: boolean,
) {
  toast(
    ({ closeToast }) => (
      <BulkAction<Lead>
        actionFn={actionFn}
        items={leads}
        onClose={closeToast}
        renderTitle={renderToastTitle}
        isAsync={isAsync}
        renderReviewItem={({ full_name, occupation }) => (
          <div className="flex border border-black-200 p-3 gap-x-2 rounded-3xl">
            <div className="flex min-w-0 flex-col gap-y-1">
              <h5 className="line-clamp-1 break-all text-md-bold">
                {full_name}
              </h5>
              {occupation ? (
                <span className="line-clamp-1 break-all text-button-xs text-black-500">
                  {occupation}
                </span>
              ) : null}
            </div>
          </div>
        )}
      />
    ),
    {
      position: "bottom-right",
      autoClose: false,
      closeButton: false,
      icon: false,
    },
  );
}
